<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznmezunlar from "@/models/mznmezunlar";
import VueHtml2pdf from 'vue-html2pdf'


export default {
  mixins: [apibtoast, apigeneric, mznmezunlar],
  props: ["FormData"],
  data() {
    return {

      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
    };
  },
  components: {
    Loader,
    VueHtml2pdf

  },
  watch: {
    FormData() {
    }
  },
  created() {
    this.Get();
  },
  methods: {
    Get() {
      this.FormData.Egitimbilgileri = JSON.parse(this.FormData.Egitimbilgileri);
      this.FormData.Isstajbilgileri = JSON.parse(this.FormData.Isstajbilgileri);
      this.FormData.Kursbilgileri = JSON.parse(this.FormData.Kursbilgileri);
      this.FormData.Sertifikabilgileri = JSON.parse(
        this.FormData.Sertifikabilgileri
      );
      this.FormData.Sinavbilgisi = JSON.parse(this.FormData.Sinavbilgisi);
      this.FormData.Yabancidilbilgisi = JSON.parse(
        this.FormData.Yabancidilbilgisi
      );
      this.FormData.Bilgisayarbilgisi = JSON.parse(
        this.FormData.Bilgisayarbilgisi
      );
      this.FormData.Yayinbilgilerim = JSON.parse(this.FormData.Yayinbilgilerim);
      this.FormData.Odulbilgileri = JSON.parse(this.FormData.Odulbilgileri);
      this.FormData.Projebilgileri = JSON.parse(this.FormData.Projebilgileri);
      this.FormData.Kulturelfaaliyetbilgileri = JSON.parse(
        this.FormData.Kulturelfaaliyetbilgileri
      );
      this.FormData.Dernekuyelikleri = JSON.parse(
        this.FormData.Dernekuyelikleri
      );
      this.FormData.Yetkinlikler = JSON.parse(this.FormData.Yetkinlikler);
      this.FormData.Referanslar = JSON.parse(this.FormData.Referanslar);
      this.FormData.Gizlilik = JSON.parse(this.FormData.Gizlilik);

    },
    generateReport() {
      this.$refs.profilpdf.generatePdf();
    }
  },
};
</script>
<template>
  <Loader>
    <b-modal id="profilpdf" size="xl" title="" title-class="font-18 pb-4" hide-footer>
      <div class="row mt-5">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <div class="text-sm-end">
            <button type="button" class="btn btn-warning btn-rounded me-5 mt-4" @click="generateReport()">
              <i class="mdi mdi-file-export-outline me-1"></i>
              Yazdır
            </button>
          </div>
        </div>
      </div>

      <VueHtml2pdf :show-layout="true" :float-layout="false" :enable-download="false" :preview-modal="true"
        :paginate-elements-by-height="1400" filename="Ozgecmis" :pdf-quality="1" :manual-pagination="false"
        pdf-format="a4" pdf-orientation="portrait" pdf-content-width="100%" ref="profilpdf">
        <section slot="pdf-content">
          <div id="exportContent">
            <div class="row">
              <div class="col-md-12">
              <div class="a4_yatay" style="margin-left:-10px;">

                <div class="profile-user mt-1">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="profile-header">
                        <div class="
                      row
                      d-flex
                      flex-column
                      justify-content-center
                      align-items-center
                    ">
                     <!--     <div class="col-md-12 mb-5">
                            <div class="image-user ">
                              <img class="navigation" v-if="FormData.Fotograf != null"
                                :src="$config.FILES_URL + 'web/' + FormData.Fotograf" alt="" />
                              <img v-if="FormData.Fotograf == null" src="@/assets/images/usericon.png" alt="" />
                            </div>
                          </div> -->

                          <div class="col-md-11 mb-5">
                            <div class="name">
                              <p class="title">{{ FormData.Adisoyadi }}</p>

                              <p v-if="FormData.Ozetbilgi != null" style="font-size: 95%;">{{ FormData.Ozetbilgi }}</p>
                            </div>
                          </div>

                          <div class="col-md-11 mb-5">
                            <div class="contact"
                              >
                              <p class="title">İletişim</p>
                              <p>{{ FormData.Eposta }}</p>
                              <p>{{ FormData.Telefon }}</p>
                              <p>{{ FormData.Evadresi }}</p>

                              <p  style="font-size: 85%;"><span class="bx bxl-linkedin-square"></span><span
                                  style="font-weight: bold; color: #8cddff;">LinkedIn: </span>{{ FormData.Linkedin }}</p>
                              <!--        <p v-if="TableData.Facebook != null"><span class="bx bxl-facebook-square"></span><span
                            style="font-weight: bold; color: #8cddff;">Facebook: </span>{{ TableData.Facebook }}</p>
                           <p><span style="font-weight: bold; color: #8cddff;">Website: </span>{{ TableData.Website }}</p> -->
                              <p style="font-size: 85%;" v-if="FormData.Twitter != null"><span class="bx bxl-twitter"></span><span
                                  style="font-weight: bold; color: #8cddff;">Twitter: </span>{{ FormData.Twitter }}</p>
                              <p style="font-size: 85%;" v-if="FormData.Instagram != null"><span class="bx bxl-instagram"></span><span
                                  style="font-weight: bold; color: #8cddff;">Instagram: </span>{{ FormData.Instagram }}
                              </p>
                            </div>
                          </div>

                          <div class="col-md-8 mb-5">
                            <div class="contact">
                              <p class="title">Adres</p>
                              <p>{{ FormData.Yasadigiulke }}</p>
                              <p>{{ FormData.Yasadigisehirvalue }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="profile-detail">
                        <div class="row">
                          <div class="col-md-6 mb-5">
                            <div class="profile-info">
                              <div class="list-group mb-2">
                                <p class="title" style="font-size: 99%;">Hakkımda</p>
                                <p class="text" style="font-size: 90%;">
                                  <span class="list-group-item bold">Doğum Tarihi: {{ FormData.Dogumtarihi |
                                    formatDateTable
                                  }}</span>

                                  <span class="list-group-item bold">Sağlık Engeli: {{ FormData.Saglikengelivalue
                                  }}</span>


                                  <!--    <span class="list-group-item bold">Ehliyet: {{ FormData.Ehliyetvalue }}</span> -->
                                  <span class="list-group-item bold">İş Arama Durumu:
                                    {{ FormData.Isaramadurumuvalue }}</span>
                                </p>
                              </div>
                              <div class=" mb-2" v-if="FormData.Egitimbilgileri != null">
                                <p class="title" style="font-size: 99%;">Eğitim</p>
                                <b-card v-for="Data in FormData.Egitimbilgileri" :key="Data.Id" style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Data.Okul }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Data.Bolum }}
                                  </b-card-text>
                                  <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                                    Data.MezuniyetTarihi | formatDateTable }}</b-card-text>
                                </b-card>
                              </div>
                              <div class=" mb-2" v-if="FormData.Isstajbilgileri != null">
                                <p class="title" style="font-size: 99%;">İş Deneyimi</p>
                                <b-card v-for="(Isbilgi, index) in FormData.Isstajbilgileri" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Isbilgi.KurumKurulusAdi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Isbilgi.Pozisyon }} / {{
                                    Isbilgi.Departman }}</b-card-text>
                                  <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                                    Isbilgi.BaslangıcYili }}-{{ Isbilgi.AyrılısYili }}</b-card-text>
                                </b-card>
                              </div>
                              <div class=" mb-2" v-if="FormData.Sinavbilgisi != null">
                                <p class="title" style="font-size: 99%;">Sınav Bilgisi</p>
                                <b-card v-for="(Sinav, index) in FormData.Sinavbilgisi" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Sinav.SinavAdi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Sinav.Not }}
                                  </b-card-text>
                                  <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                                    Sinav.Yil }}</b-card-text>
                                </b-card>
                              </div>
                              <div class=" mb-2" v-if="FormData.Odulbilgileri != null">
                                <p class="title" style="font-size: 99%;">Ödüller</p>
                                <b-card v-for="(Odul, index) in FormData.Odulbilgileri" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Odul.OdulunAdi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Odul.OduluVerenKurum }}
                                  </b-card-text>
                                  <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                                    Odul.OdulTarihi }}</b-card-text>
                                </b-card>
                              </div>
                              <div class=" mb-2" v-if="FormData.Dernekuyelikleri != null">
                                <p class="title" style="font-size: 99%;">Üye Olunan Topluluk</p>
                                <b-card v-for="(Dernek, index) in FormData.Dernekuyelikleri" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Dernek.Adi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Dernek.Unvan }}
                                  </b-card-text>
                                  <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                                    Dernek.Tur }}</b-card-text>
                                </b-card>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <div class="profile-info">
                              <div v-if="FormData.Kariyerhedefi != null" class=" mb-5">
                                <p class="title" style="font-size: 99%;">Kariyer Hedefi</p>
                                <p class="text">
                                  {{ FormData.Kariyerhedefi }}
                                </p>
                              </div>
                              <div class=" mb-2" v-if="FormData.Kulturelfaaliyetbilgileri != null">
                                <p class="title" style="font-size: 99%;">İlgi Alanları</p>
                                <b-card v-for="(Faliyet, index) in FormData.Kulturelfaaliyetbilgileri" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Faliyet.Adi }}</b-card-title>

                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Faliyet.Duzey }}
                                  </b-card-text>
                                  <b-card-text style="margin-bottom: -5px;">{{ Faliyet.Tur }}
                                  </b-card-text>
                                  <b-card-text v-if="Faliyet.Tur == 'Diğer'"
                                    style="margin-top: -10px; margin-bottom: -5px;">{{ Faliyet.TurAciklama }}
                                  </b-card-text>
                                </b-card>
                              </div>

                              <div class=" mb-2" v-if="FormData.Projebilgileri != null">
                                <p class="title" style="font-size: 99%;">Projeler</p>
                                <b-card v-for="(Projeler, index) in FormData.Projebilgileri" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -20px">{{ Projeler.Adi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Projeler.Kurum }}
                                  </b-card-text>
                                  <b-card-text style="margin-bottom: -5px;">{{ Projeler.Ozet }}
                                  </b-card-text>
                                  <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                                    Projeler.Yil }}</b-card-text>
                                </b-card>
                              </div>

                              <div class=" mb-2" v-if="FormData.Yabancidilbilgisi != null">
                                <p class="title" style="font-size: 99%;">Yabancı Diller</p>
                                <b-card v-for="(Dil, index) in FormData.Yabancidilbilgisi" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -5px">{{ Dil.Adi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Dil.Aciklama }}
                                  </b-card-text>
                                </b-card>
                              </div>

                              <div class=" mb-2" v-if="FormData.Kursbilgileri != null">
                                <p class="title" style="font-size: 95%;">Kurs/Eğitim/Seminer/Kongre Bilgileri</p>
                                <b-card v-for="(Kurs, index) in FormData.Kursbilgileri" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -20px">{{ Kurs.KursAdi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Kurs.Kurum }}
                                  </b-card-text>
                                  <b-card-text style="margin-top: -5px; margin-bottom: -5px;">{{ Kurs.Aciklama }}
                                  </b-card-text>
                                  <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                                    Kurs.Sure }}</b-card-text>
                                </b-card>
                              </div>

                              <div class=" mb-2" v-if="FormData.Sertifikabilgileri != null">
                                <p class="title" style="font-size: 99%;">Sertifika/Belge/Eğitim Bilgileri</p>
                                <b-card v-for="(Sertifika, index) in FormData.Sertifikabilgileri" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Sertifika.SertifikaAdi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Sertifika.Kurum }}
                                  </b-card-text>
                                  <b-card-text style="margin-top: -5px; margin-bottom: -5px;">{{ Sertifika.Turu }}
                                  </b-card-text>
                                  <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -5px;">{{
                                    Sertifika.SaglananFaydaGelisim }}</b-card-text>
                                  <b-card-text class="small text-muted" style="margin-bottom: -10px;">{{
                                    Sertifika.Kategori }}</b-card-text>
                                </b-card>
                              </div>
                              <div class=" mb-2" v-if="FormData.Bilgisayarbilgisi != null">
                                <p class="title" style="font-size: 99%;">Bilgisayar Bilgisi</p>
                                <b-card v-for="(Bilgisayar, index) in FormData.Bilgisayarbilgisi" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Bilgisayar.Adi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Bilgisayar.Kurum }}
                                  </b-card-text>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Bilgisayar.Aciklama }}
                                  </b-card-text>
                                </b-card>
                              </div>
                              <div class=" mb-2" v-if="FormData.Yetkinlikler != null">
                                <p class="title" style="font-size: 99%;">Yetkinlikler</p>
                                <b-card v-for="(Yetkinlikler, index) in FormData.Yetkinlikler" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Yetkinlikler.Adi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Yetkinlikler.Aciklama }}
                                  </b-card-text>
                                </b-card>
                              </div>
                              <div class="mb-5" v-if="FormData.Yayinbilgilerim != null">
                                <p class="title" style="font-size: 99%;">Yayın Bilgilerim</p>
                                <b-card v-for="(Yayın, index) in FormData.Yayinbilgilerim" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Yayın.YayininAdi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Yayın.Tur }}
                                  </b-card-text>
                                  <b-card-text style="margin-bottom: -10px;">{{ Yayın.YayinlandigiKitapEvi }}/{{
                                    Yayın.YayinlandigiYil }} 
                                  </b-card-text>
                                </b-card>
                              </div>
                              <div class="mb-5" v-if="FormData.Referanslar != null">
                                <p class="title" style="font-size: 99%;">Referanslar</p>
                                <b-card v-for="(Referanslar, index) in FormData.Referanslar" :key="index"
                                  style="margin-top: -10px">
                                  <b-card-title style="margin-top: -10px">{{ Referanslar.Adisoyadi }}</b-card-title>
                                  <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Referanslar.Unvan }}
                                  </b-card-text>
                                  <b-card-text style="margin-top: -5px; margin-bottom: -2px;">{{ Referanslar.Eposta }}
                                  </b-card-text>
                                  <b-card-text class="small text-muted" style="margin-bottom: -10px;">{{
                                    Referanslar.CepTelefonu }}</b-card-text>
                                </b-card>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </section>
      </VueHtml2pdf>

    </b-modal>
  </Loader>
</template>

